module.exports = "<div class=\"d-flex align-items-center justify-content-center justify-content-sm-between\"><span>Delete my Profile</span><gmc-switch class=mx-4 value=$ctrl.isDeleteBtnEnabled></gmc-switch><button class=\"btn btn-delete\" type=button ng-disabled=!$ctrl.isDeleteBtnEnabled ng-click=$ctrl.showDeleteConfirm()>Delete Profile</button></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/delete-account/delete-account.component.html
// module id = 841
// module chunks = 31